import { LogLevel } from '@/hooks/telemetry';
import type { ButtonPreset } from '@/constants/componentPresets';

export const CLICK_INVESTIGATION_ID = 'click-investigation--team-stack-card--2026-05-25';
export const CBUTTON_SEQ_COMPONENT = 'Cbutton';

export enum ButtonClickInvestigationEvent {
  HandleClick = 'click-inv:cbutton-handleClick',
  WrapperClickCapture = 'click-inv:cbutton-wrapper-click-capture',
  WrapperPointerDownCapture = 'click-inv:cbutton-wrapper-pointerdown-capture',
}

interface CreateClickInvestigationPayloadInput {
  isInteractive: boolean;
  disabled: boolean;
  isLoading: boolean;
  hasOnClick: boolean;
  preset: ButtonPreset;
  label?: string;
}

export type ClickInvestigationPayload = Record<string, unknown> & {
  isInteractive: boolean;
  disabled: boolean;
  isLoading: boolean;
  hasOnClick: boolean;
  preset: ButtonPreset;
  label: string | null;
};

export function createClickInvestigationPayload({
  isInteractive,
  disabled,
  isLoading,
  hasOnClick,
  preset,
  label,
}: CreateClickInvestigationPayloadInput): ClickInvestigationPayload {
  return {
    isInteractive,
    disabled,
    isLoading,
    hasOnClick,
    preset,
    label: label ?? null,
  };
}

export function resolveClickInvestigationLogLevel(isInteractive: boolean): LogLevel {
  return isInteractive ? LogLevel.Info : LogLevel.Warning;
}
